var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.bookmarkFilter,
          expression: "bookmarkFilter",
        },
      ],
      staticClass: "sidebar-selectlist",
      on: {
        change: function change($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.bookmarkFilter = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        },
      },
    },
    [
      _c(
        "option",
        {
          attrs: {
            value: "all",
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.$gettext("alle")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "contents",
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.$gettext("Arbeitsplatz")) + "\n    ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.courses, function (course) {
        return _c(
          "option",
          {
            key: course.id,
            domProps: {
              value: course.id,
            },
          },
          [_vm._v("\n        " + _vm._s(course.attributes.title) + "\n    ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }